<template>
  <div class="content">
    <div class="pageTit">
      <dl>
        <dt>
          チケット <span class="blue--text darken-1">{{ ticket.dispId }}</span>
        </dt>
      </dl>
      <div class="brandBox">
        <ticket-brand-select v-show="false"></ticket-brand-select>
      </div>
    </div>
    <div class="ticketDetailCon">

      <div class="ticketMergeBox subOn">
        <v-btn v-if="ticket.parentId || ticket.subTickets.length > 0" outline class="UXbtn small" @click="revertMerge()" :disabled="!isPermission['split']">組合わせの解除</v-btn>
        <span class="ticket" v-if="ticket.parentId">
          <strong>メインチケット:</strong> <span><a @click="goTicketView(ticket.parentDispId)" class="blue--text">{{ ticket.parentDispId }}</a></span>
          </span>
        <span class="ticket" v-if="ticket.subTickets.length > 0">
          <strong>サブチケット: </strong> <span v-for="(item, index) in ticket.subTickets" v-bind:key="index" v-bind:id="item.id"><a @click="goTicketView(item.dispId)" class="blue--text">{{ item.dispId }}</a></span>
          </span>
      </div>
<!--      <div class="font-weight-bold body-1 br-5 pa-2 d-inline-block grey lighten-3 border mr-2"-->
<!--           v-if="ticket.parentId">-->
<!--        <span class="teal darken-1 white&#45;&#45;text px-3 py-1 br-5">부모 티켓</span>-->
<!--        <span class="blue&#45;&#45;text darken-1 cursor mx-1"-->
<!--              @click="goTicketView(ticket.parentDispId)">{{ ticket.parentDispId }}</span>-->
<!--      </div>-->
<!--      <div class="font-weight-bold body-1 br-5 pa-2 d-inline-block grey lighten-3 border"-->
<!--           v-if="ticket.subTickets.length > 0">-->
<!--        <span class="teal lighten-1 white&#45;&#45;text px-3 py-1 br-5">자식 티켓</span>-->
<!--        <span class="blue&#45;&#45;text darken-1 cursor mx-1"-->
<!--              v-for="(item, index) in ticket.subTickets" v-bind:key="index" v-bind:id="item.id"-->
<!--              @click="goTicketView(item.dispId)">{{ item.dispId }}</span>-->
<!--      </div>-->
      <div class="require-notice-box">
        <span class="require-notice-text require-before">必須情報</span>
      </div>
      <table class="tbl theadNotBg">
        <colgroup>
          <col style="width:170px" />
          <col style="width:322px" />
          <col style="width:140px" />
          <col />
        </colgroup>
        <tbody>
        <tr>
          <th>顧客名</th>
          <td colspan="3">{{this.customer.name || '-'}}</td>
        </tr>
        <tr>
          <th>電話番号</th>
          <td>
            <div class="inlineFlex">
              {{this.customer.phoneNumber || '-'}}
              <!-- 일본에서 사용하지 않으므로 주석처리
              <v-btn outline class="UXbtn small" style="margin-left:20px;" @click="smsPopup = true" :disabled="!isPermission['sms'] && !isPermission['kakao']">文字/通知トーク送信</v-btn> -->
            </div>
          </td>
          <th>メールアドレス</th>
          <td>{{this.customer.email || '-'}}</td>
        </tr>
        <tr>
          <th>担当者</th>
          <td colspan="3">
            <v-autocomplete
              item-text="itemText"
              item-value="id"
              v-model="agent.id"
              :loading="loadingAgent"
              :items="agents"
              placeholder="担当者選択"
              :search-input.sync="searchAgent"
              class="UXautocomplete UXselect"
              color="#6D8DFF"
              hide-details
              outline
              @change="changeAgentMail(agent.id)"
              :disabled="!isPermission['update']"
            ></v-autocomplete>
          </td>
        </tr>
        <tr>
          <th>
            <span class="require-after">タイトル</span><br/>
            <span class="template-name-length gray">(<span class="colorBlue">{{ticket.subject.length}}</span>/80)</span>
          </th>
          <td colspan="3">
            <v-text-field
              v-model="ticket.subject"
              maxlength="80"
              class="UXinput UXicon-edit"
              hide-details
              outline
              :disabled="!isPermission['update']"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <th>チケット状態</th>
          <td>
            <v-select
              item-text="text"
              item-value="id"
              v-model="ticket.status"
              :items="statuses"
              class="UXselect"
              color="#6D8DFF"
              hide-details
              outline
              solo
              :disabled="!isPermission['update']"
              no-data-text="データがありません。"
            ></v-select>
          </td>
          <th>優先順位</th>
          <td>
            <v-select
              item-text="name"
              item-value="id"
              v-model="ticket.priority"
              :items="priorities"
              class="UXselect"
              color="#6D8DFF"
              deleteable
              hide-details
              outline
              solo
              :disabled="!isPermission['update']"
              no-data-text="データがありません。"
            ></v-select>
          </td>
        </tr>
        <tr v-if="serviceList.length !== 0">
          <th>サービス名</th>
          <td colspan="3">
            <v-select
              v-model="ticket.selectedService"
              :items="serviceList"
              item-value="value"
              item-text="name"
              :disabled="!isPermission['update'] || ticket.ticketIncomingChannel !== 'CALL'"
              placeholder="サービスを選択してください。"
              class="UXselect"
              color="#6D8DFF"
              hide-details
              outline
              solo
              no-data-text="データがありません。"
            ></v-select>
          </td>
        </tr>
        <tr>
          <th>分類カテゴリ</th>
          <td colspan="3">
            <ticket-detail-counsel-type
              ref="ticketCounselType"
              :initDetailPage="true"
              :updateMajorTaskType="updateMajorTaskType"
              :updateMiddleTaskType="updateMiddleTaskType"
              :updateMinorTaskType="updateMinorTaskType"
              :disabled="!isPermission['update']"
            ></ticket-detail-counsel-type>
          </td>
        </tr>
        <tr>
          <th class="topTh" style="padding-top: 20px">タグ</th>
          <td colspan="3">
            <div class="UXtagInp">
              <v-text-field
                ref="tagInp"
                class="tag-input"
                v-model="tagInput"
                placeholder="タグ入力"
                color="6D8DFF"
                :append-icon="tagInput && tagInput.length ? 'close': 'edit'"
                @input="resize"
                @keydown.enter.exact.prevent
                @keyup.enter.exact="sendTag()"
                @click:append="tagInput && tagInput.length ? removeTaginp() : sendTag()"
                hide-details
                outline
                solo
                maxLength="100"
                :disabled="!isPermission['update']"
              ></v-text-field>
              <div ref="tagHideTxt" class="hideTagText">{{tagInput}}</div>
              <p v-for="(item, index) in localTags" :key="index" class="UXtagItem" :class="{'tagDisabled': !isPermission['update']}">{{item}} <i class="UXicon-close" @click="deleteTag(item)"></i></p>
            </div>
          </td>
        </tr>
        <tr>
          <th class="topTh">メモ<br/>
            <span class="template-name-length gray">(<span class="colorBlue">{{ ticket.memo ? ticket.memo.length : '0'}}</span>/5000)</span></th>
          <td colspan="3">
            <v-textarea
              hide-details
              no-resize
              outline
              height="140"
              class="UXtextarea"
              placeholder="メモを入力してください。"
              maxLength="5000"
              v-model="ticket.memo"
              :disabled="!isPermission['memo']"
            ></v-textarea>
          </td>
        </tr>
        <tr>
          <th class="topTh">ヒストリー追加</th>
          <td colspan="3">
            <jodit-editor v-model="contents" :setConfigs="setConfigs" />
          </td>
        </tr>
        </tbody>
      </table>

      <div class="subTit" v-if="summaryOptionList.length">
        追加の相談記録を入力
      </div>
      <table class="tbl theadNotBg customSummaryTbl" v-if="summaryOptionList.length">
        <colgroup>
          <col style="width:140px" />
          <col style="width:322px" />
          <col style="width:140px" />
          <col />
        </colgroup>
        <tbody>
        <tr v-for="(customItem, index) in summaryOptionList" :key="index">
          <th>
            {{ customItem[0].title }}
            <span v-if="customItem[0].type === 'TEXT'">(<span>{{ customItem[0].value ? customItem[0].value.length : 0 }}</span>/30)</span>
          </th>
          <td>
            <v-text-field
              v-if="customItem[0].type === 'TEXT'"
              v-model="customItem[0].value"
              :placeholder="customItem[0].placeholder"
              class="UXinput UXicon-edit"
              outline
              solo
              maxLength="30"
            ></v-text-field>
            <v-select
              v-if="customItem[0].type === 'SELECT'"
              v-model="customItem[0].value"
              :items="getItemList(customItem[0].optionCode)"
              @change="fetchItemInfo(customItem[0])"
              item-text="value"
              class="UXselect"
              :placeholder="customItem[0].placeholder"
              hide-details
              outline
              solo
              no-data-text="データがありません。"
            ></v-select>
          </td>

          <th v-if="customItem[1]">
            {{ customItem[1].title }}
            <span v-if="customItem[1].type === 'TEXT'">(<span>{{ customItem[1].value ? customItem[1].value.length : 0 }}</span>/30)</span>
          </th>
          <td v-if="customItem[1]">
            <v-text-field
              v-if="customItem[1].type === 'TEXT'"
              v-model="customItem[1].value"
              :placeholder="customItem[1].placeholder"
              class="UXinput UXicon-edit"
              outline
              solo
              maxLength="30"
            ></v-text-field>
            <v-select
              v-if="customItem[1].type === 'SELECT'"
              v-model="customItem[1].value"
              :items="getItemList(customItem[1].optionCode)"
              @change="fetchItemInfo(customItem[1])"
              item-text="value"
              class="UXselect"
              :placeholder="customItem[1].placeholder"
              hide-details
              outline
              solo
              no-data-text="データがありません。"
            ></v-select>
          </td>
        </tr>
        </tbody>
      </table>

      <p class="ritTxt">最終更新 : {{ ticketModifyDate }}</p>
      <div class="cenBtn">
        <v-btn v-if="!$route.query.hideCancel" outline large class="UXbtn" @click="goList">キャンセル</v-btn>
        <v-btn round dark large color="#ff8c8c" class="UXbtn" @click="modifyTicket" :disabled="!isPermission['update'] && !isPermission['event'] && !isPermission['memo']">確認</v-btn>
      </div>

      <div class="listBox">
        <v-tabs v-model="ticketTabs" class="UXTab">
          <v-tab href="#TICKET" @click="updateIncidentList">ヒストリー</v-tab>
          <v-tab href="#MEMO" @click="showHistoryMemoDialog">メモ履歴</v-tab>
        </v-tabs>
        <div v-show="ticketTabs === 'TICKET'">
          <ticket-incident-list :isPermission="isPermission"></ticket-incident-list>
        </div>
        <div v-show="ticketTabs === 'MEMO'">
          <ticket-memo-history-dialog :ticketId="ticket.id"></ticket-memo-history-dialog>
        </div>
      </div>
    </div>
    <v-dialog v-model="smsPopup" width="350px" persistent>
      <div class="layerPopup smsLayer">
        <div class="layerContent">
          <div>
            <v-tabs v-model="smsTabs" class="UXTab">
              <v-tab href="#SMS" v-if="isPermission['sms']">SMS</v-tab>
              <v-tab href="#KAKAO" v-if="isPermission['kakao'] ">通知トーク</v-tab>
            </v-tabs>
            <div class="callLayerCon ticketSmsLayerCon">
              <div class="dimmed" v-if="isDimmed">
                <dl>
                  <dt>使用中のサービスではありません。</dt>
                  <dd>ブランド設定 > 'チャネル連動'で <br/><span class="dimmed-menu-text">'{{ smsTabs === 'SMS' ? 'メッセージ' : '通知トーク'}}'</span> 使用設定を設定してください。</dd>
                </dl>
              </div>
              <div v-show="isPermission['sms'] && smsTabs === 'SMS'">
                <ticket-message
                  :customerPhoneNumber="customer.phoneNumber"
                  :ticketId="ticket.id"
                  :setSmsMessageAvailable="setSmsMessageAvailable"
                  :msg-count-data="msgCountData.SMS"
                  @sendMsgAndUpdateCount="(obj) => { msgCountData[obj.type] = obj.count }"
                ></ticket-message>
              </div>
              <div v-show="isPermission['kakao'] && smsTabs === 'KAKAO'">
                <ticket-instant-message
                  :customerNumber="customer.phoneNumber"
                  :ticketId="ticket.id"
                  :setKakaoInstantMessageAvailable="setKakaoInstantMessageAvailable"
                  :msg-count-data="msgCountData.KAKAO"
                  @sendMsgAndUpdateCount="(obj) => { msgCountData[obj.type] = obj.count }"
                ></ticket-instant-message>
              </div>
            </div>
          </div>
        </div>
        <div class="layerClose">
          <v-btn flat icon @click="smsPopup = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ticketIncidentMemo from './fragments/ticket_incident_memo'
import ticketMessage from './fragments/ticket_message'
import ticketInstantMessage from './fragments/ticket_instant_message'
import ticketIncidentList from './fragments/ticket_incident_list'
import {mapGetters, mapMutations} from 'vuex'
import ticketTagList from './component/ticket_tag_list'
import Helpers from '@/util/helpers'
import eventBus from '@/event_bus'
import eventType from '@/components/menus/ticket/enums/eventType'
import ticketDetailCounselType from './component/ticketlist/layout/ticket_detail_counsel_type'
import ticketBrandSelect from '@/components/menus/ticket/ticket_brand_select.vue'
import TicketListUtil from './util/ticket_list_util'
import ticketMemoHistoryDialog from './component/ticket_memo_history_dialog'
import event from './enums/eventType'
import util from 'util/'
import permissions from '@/util/permissions'
import axios from 'axios'

export default {
  metaInfo: {
    title: 'チケットの詳細'
  },
  components: {
    ticketIncidentMemo,
    ticketMessage,
    ticketIncidentList,
    ticketTagList,
    ticketDetailCounselType,
    ticketBrandSelect,
    ticketInstantMessage,
    ticketMemoHistoryDialog
  },
  data () {
    return {
      callDomain: process.env.CALL_URL,
      loading: false,
      loadingAgent: false,
      ticket: {
        id: null,
        subject: '',
        memo: '',
        dispId: '',
        modifyDate: null,
        priority: 'NORMAL',
        status: 'ACTIVE',
        tags: [],
        subTickets: [],
        selectedService: null,
        ticketIncomingChannel: ''
      },
      priorities: [],
      statuses: [],
      agent: {
        id: null,
        name: '',
        email: ''
      },
      agents: [],
      brandId: null,
      majorTaskType: {},
      middleTaskType: {},
      minorTaskType: {},
      customer: {
        name: '',
        phoneNumber: '',
        email: ''
      },
      currentTab: 'tab-memo',
      kakaoInstantMessageAvailable: false,
      smsMessageAvailable: false,
      searchAgent: null,
      ticketAgent: null,
      contents: '',
      setConfigs: {
        buttons: ['bold', 'strikethrough', 'underline', 'italic', 'paragraph', 'font', 'fontsize', 'brush', 'ul', '|', 'image', 'file'],
        configs: {
          imageDefaultWidth: 100,
          minHeight: 200,
          height: 200,
          toolbarButtonSize: 'small',
          showCharsCounter: false,
          disabled: false,
          i18n: {
            ko: {
              'Type something': '内容を入力してください。',
              'Bold': '太字',
              'Drop image': 'ファイルをここに置くか',
              'Drop file': 'ファイルをここに置くか',
              'or click': 'クリックしてください'
            }
          }
        }
      },
      ticketTabs: 'TICKET',
      smsTabs: 'SMS',
      smsPopup: false,
      localTags: [],
      tagInput: '',
      title: '使用中のサービスではありません。',
      dimmedContext: `<span>使用可否はアドミンで設定可能です。</span>`,
      marginLeft: '-135px',
      channelData: {
        SMS: {
          serviceInfos: [],
          notDimmed: false
        },
        KAKAO_INSTANT_MESSAGE: {
          serviceInfos: [],
          templates: [],
          notDimmed: false
        }
      },
      keyList: ['update', 'split', 'sms', 'kakao', 'memo', 'read', 'listen', 'event'],
      pmsKey: {
        update: 'UPDATE_TICKET',
        split: 'SPLIT_TICKET',
        sms: 'SEND_SMS',
        kakao: 'SEND_K_ALARM',
        memo: 'UPDATE_TICKET_MEMO',
        read: 'OPEN_CHAT',
        listen: 'LISTEN_CALL',
        event: 'CREATE_TICKET_EVENT'
      },
      isPermission: {
        update: false,
        split: false,
        sms: false,
        kakao: false,
        memo: false,
        read: false,
        listen: false,
        event: false
      },
      summaryCustomObject: {},
      summaryOptionObject: {},
      summaryOptionList: [],
      serviceList: [],
      msgCountData: {
        SMS: {
          isUnlimitedMessageCountBrand: true,
          monthFreeSendCount: 0
        },
        KAKAO: {
          isUnlimitedMessageCountBrand: true,
          monthFreeSendCount: 0
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'loginId',
      'agentId',
      'currentTicketBrandId',
      'ticketAgentId',
      'incidentList',
      'currentBrandId',
      'callMode'
    ]),
    ticketModifyDate () {
      return this.convert(this.ticket.modifyDate)
    },
    isDimmed () {
      const channel = this.smsTabs === 'SMS' ? this.smsTabs : 'KAKAO_INSTANT_MESSAGE'
      return this.channelData[channel] && !this.channelData[channel].notDimmed
    }
  },
  watch: {
    // searchAgent (newVal) {
    // newVal !== this.agent.itemText && this.callAgentListByBrandId(newVal)
    // newVal !== this.agent.itemText
    // },
    currentTicketBrandId () {
      if (this.currentTicketBrandId) {
        this.resetTaskType()
        if (!this.$targetMake.isSeller && this.callMode === 'KT') { this.checkCall() }
      }
    },
    smsPopup (val) {
      if (val) {
        this.getChannels()
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    const brandId = util.parseLoginToken().agentMappingBrandViews[0].brandId
    if (brandId) {
      axios({
        method: 'get',
        url: `/api/brand/${brandId}/summary-options`
      }).then(response => {
        if (response.data.code === 0) {
          next(vm => {
            if (response && response.data && response.data.data) {
              const customOption = response.data.data
              if (customOption.length) {
                vm.summaryOptionList = vm.twoDepthArrayFromArray(customOption, 2)

                if (customOption.length) {
                  customOption.forEach(option => {
                    vm.summaryOptionObject[option.code] = option
                  })
                }
              }
            }
          })
        } else {
          next()
        }
      }).finally(next)
    } else {
      next()
    }
  },
  created () {
    this.checkPermission()
    if (!this.$route.query.displayId) {
      this.$alertMsg('必須値が存在しません。')
    } else {
      this.ticket.dispId = this.$route.query.displayId
      const mappingBrandId = util.parseLoginToken().agentMappingBrandViews[0].brandId
      if (!this.currentBrandId) {
        this.brandId = mappingBrandId
      } else {
        this.brandId = this.currentBrandId
      }
      this.fetchTicketDataByDisplayId()
      this.ticketEnums()
      if (!this.$targetMake.isSeller && this.callMode === 'KT') { this.checkCall() }
    }
  },
  methods: {
    ...mapMutations([
      'changeTicketBrandId'
    ]),
    checkPermission () {
      this.keyList.map(item => {
        this.isPermission[item] = permissions.checkAction(this.pmsKey[item])
      })
      this.$set(this.setConfigs.configs, 'disabled', !this.isPermission['event'])
    },
    setAllowPermission () {
      this.keyList.map(item => {
        this.isPermission[item] = true
      })
    },
    clearTags () {
      this.ticket.tags = []
    },
    changeAgentMail (id) {
      this.agent.email = this.agents.filter(a => a.id === id)[0].email
    },
    ticketEnums () {
      this.axios.get('/gateway/ticket/enums')
        .then(res => {
          if (res.data.code === 0) {
            const data = res.data.data

            data.ticketStatus.forEach((status, index) => {
              if (index === 0) this.statusType = status.key
              let item = {
                id: status.key,
                text: status.value
              }
              this.statuses.push(item)
            })
            data.ticketPriority.forEach((priority, index) => {
              if (index === 0) this.priorityType = priority.key
              let item = {
                id: priority.key,
                name: priority.value
              }
              this.priorities.push(item)
            })
            this.$forceUpdate()
          }
        })
    },
    callAgentListByBrandId () {
      let ticketBrandId = this.currentTicketBrandId
      if (ticketBrandId) {
        this.loadingAgent = true
        this.axios.get(`/gateway/ticket/brand/${this.currentTicketBrandId}/agents?approvalStatuses=ENABLE`).then((res) => {
          if (res.data.code === 0) {
            this.initAgents()
            res.data.data.filter(a => this.agent.id === a.id || a.approvalStatus === '認証完了').forEach(agent => {
              agent.itemText = `${agent.name} (${agent.email})`
              this.agents.push(agent)
            })
          }
        }).finally(() => {
          this.loadingAgent = false
        })
      }
    },
    revertMerge () {
      this.$confirmMsg('', 'このチケットに関連するすべてのチケットとの組合わせが解除されます。<br/>解除しますか?', () => {
        this.axios.put(`/api/brand/${this.brandId}/tickets/${this.ticket.id}/revert`).then(result => {
          if (result.data.code === 0) {
            this.$alertMsg('組合わせが解除されました。')
          }
        }).then(() => this.fetchTicketDataByDisplayId())
          .then(() => this.updateIncidentList())
      }, '確認')
    },
    goTicketView (parentDispId) {
      const displayId = parentDispId.replace('#', '')
      window.open(location.protocol.concat('//', window.location.hostname + ':' + window.location.port, `/ticket/ticket_details?displayId=${displayId}`), '_blank')
    },
    convert (dateTime) {
      return dateTime !== undefined ? Helpers.convertCreateDateToYYYYMMDDhhmmss(dateTime) : '-'
    },
    fetchTicketDataByDisplayId () {
      this.axios.get('/gateway/ticket/details', {
        params: {
          displayId: this.ticket.dispId.replace('#', '')
        }
      })
        .then(result => {
          if (result.data.code !== 0) {
            if (result.data.code === -30001) {
              this.$router.go(-1)
            }
            return
          }

          const data = result.data.data
          if (data.summaryCustomData.length) {
            data.summaryCustomData.forEach(cItem => {
              this.summaryCustomObject[cItem.optionCode] = cItem
            })
          }

          this.fetchSummaryCustomOption()

          this.changeTicketBrandId(data.brandId)
          this.agent.id = data.agentView.id
          this.agent.name = data.agentName
          this.agent.email = data.agentView.email
          this.agent.itemText = `${data.agentName} (${data.agentView.email})`
          if (this.agent.id && this.agent.name) {
            this.ticketAgent = {id: this.agent.id, name: this.agent.name, email: this.agent.email}
          }
          this.ticket.id = data.id
          this.ticket.subject = data.subject
          this.ticket.memo = data.memo
          this.ticket.dispId = data.dispId
          this.ticket.modifyDate = data.modifyDate
          this.ticket.priority = data.priority
          this.ticket.status = data.status
          this.ticket.parentId = data.parentTicketId
          this.ticket.subTickets = data.subTickets
          this.ticket.parentDispId = data.parentTicketDispId
          this.ticket.selectedService = data.channelId ? data.channelId : null
          this.ticket.ticketIncomingChannel = data.ticketIncomingChannel
          this.localTags = data.tags.map(d => d.text)
          if (data.customerView) {
            this.customer.name = data.customerView.name ? data.customerView.name : ''
            this.customer.phoneNumber = data.customerView.phoneNumber ? data.customerView.phoneNumber : ''
            this.customer.email = data.customerView.email ? data.customerView.email : ''
          }
          if (Array.isArray(data.taskTypes)) {
            let majorType = TicketListUtil.findTaskType(data.taskTypes, 'MAJOR_CLASS')
            let middleType = TicketListUtil.findTaskType(data.taskTypes, 'MIDDLE_CLASS')
            let minorType = TicketListUtil.findTaskType(data.taskTypes, 'MINOR_CLASS')
            this.$refs.ticketCounselType.initTaskType({
              majorTaskType: majorType,
              middleTaskType: middleType,
              minorTaskType: minorType
            })
          }
          this.showHistoryMemoDialog()
          this.clearTags()
          data.tags.forEach(tag => {
            let item = {id: tag.id, text: tag.text}
            this.ticket.tags.push(item)
          })
        }).then(() => this.callAgentListByBrandId())
    },
    // fetchTicketData () {
    //   this.axios.get(`${this.ticketDomain}/api/ticket/${this.ticket.id}`)
    //     .then(result => {
    //       if (result.data.code !== 0) {
    //         if (result.data.code === -30001) {
    //           this.$router.go(-1)
    //         }
    //         return
    //       }
    //       const data = result.data.data
    //       this.changeTicketBrandId(data.brandId)
    //       this.agent.id = data.agentView.id
    //       this.agent.name = data.agentName
    //       this.agent.email = data.agentView.email
    //       this.ticket.subject = data.subject
    //       this.ticket.memo = data.memo
    //       this.ticket.dispId = data.dispId
    //       this.ticket.modifyDate = data.modifyDate
    //       this.ticket.priority = data.priority
    //       this.ticket.status = data.status
    //       this.ticket.parentId = data.parentTicketId
    //       this.ticket.subTickets = data.subTickets
    //       this.ticket.parentDispId = data.parentTicketDispId
    //       if (data.customerView) {
    //         this.customer.name = data.customerView.name ? data.customerView.name : '-'
    //         this.customer.phoneNumber = data.customerView.phoneNumber ? data.customerView.phoneNumber : '-'
    //       }
    //       if (Array.isArray(data.taskTypes)) {
    //         let majorType = TicketListUtil.findTaskType(data.taskTypes, 'MAJOR_CLASS')
    //         let middleType = TicketListUtil.findTaskType(data.taskTypes, 'MIDDLE_CLASS')
    //         let minorType = TicketListUtil.findTaskType(data.taskTypes, 'MINOR_CLASS')
    //         this.$refs.ticketCounselType.initTaskType({
    //           majorTaskType: majorType,
    //           middleTaskType: middleType,
    //           minorTaskType: minorType
    //         })
    //       }
    //
    //       this.clearTags()
    //       data.tags.forEach(tag => {
    //         let item = {id: tag.id, text: tag.text}
    //         this.ticket.tags.push(item)
    //       })
    //     }).then(() => this.callAgentListByBrandId())
    // },
    updateIncidentList () {
      eventBus.$emit(eventType.FETCH_INCIDENT_LIST)
    },
    modifyTicket () {
      if (this.loading === false) {
        this.loading = true
        if (!this.ticket.dispId) {
          this.loading = false
          this.$alertMsg('正常ではない経路です。')
          return
        }
        if (this.ticket.subject.trim().length === 0) {
          this.loading = false
          this.$alertMsg('タイトルを入力してください。')
          return
        }

        let summaryCustomData = null
        if (this.summaryOptionList.length) {
          const customDataArr = this.summaryOptionList.flatMap(item => item).filter(item => !!item.value)
          if (customDataArr.length) {
            summaryCustomData = customDataArr
          }
        }

        let channelId = null
        if (this.ticket.selectedService) {
          channelId = this.ticket.selectedService
        }

        let counselData = this.$refs.ticketCounselType.getAllTaskType()
        let majorTaskTypeId = TicketListUtil.getAvailTaskTypeId(counselData.majorTaskType)
        let middleTaskTypeId = TicketListUtil.getAvailTaskTypeId(counselData.middleTaskType)
        let minorTaskTypeId = TicketListUtil.getAvailTaskTypeId(counselData.minorTaskType)
        this.axios.put(`/api/brand/${this.brandId}/tickets/${this.ticket.id}`, {
          transferTicketAgentId: this.ticketAgentId,
          eventCode: 1101,
          incidentContent: this.contents || null,
          majorTaskTypeId: majorTaskTypeId,
          memo: this.ticket.memo || '',
          middleTaskTypeId: middleTaskTypeId,
          minorTaskTypeId: minorTaskTypeId,
          modifyBy: this.loginId,
          subject: this.ticket.subject || null,
          tagContents: this.localTags,
          targetTicketAgentId: this.agent.id,
          ticketPriority: this.ticket.priority,
          ticketStatus: this.ticket.status,
          summaryCustomData,
          channelId
        }).then(result => {
          if (result.data.code !== 0) {
            this.$alertMsg(result.data.message)
            return
          }
          this.updateIncidentList()
          this.showHistoryMemoDialog()
          this.contents = ''
          this.ticket.modifyDate = result.data.data.modifyDate

          this.$alertMsg('修正が完了しました。')
        }).finally(() => {
          this.loading = false
        })
      }
      // if (this.loading === false) {
      //   this.loading = true
      //   if (!this.ticket.dispId) {
      //     this.loading = false
      //     this.$alertMsg('정상적이지 않은 경로입니다.')
      //     return
      //   }
      //
      //   let counselData = this.$refs.ticketCounselType.getAllTaskType()
      //   let majorTaskTypeId = TicketListUtil.getAvailTaskTypeId(counselData.majorTaskType)
      //   let middleTaskTypeId = TicketListUtil.getAvailTaskTypeId(counselData.middleTaskType)
      //   let minorTaskTypeId = TicketListUtil.getAvailTaskTypeId(counselData.minorTaskType)
      //
      //   this.axios.post(`${this.ticketDomain}/api/ticket/modify`, {
      //     ticketId: this.ticket.id,
      //     memo: this.ticket.memo,
      //     subject: this.ticket.subject,
      //     ticketAgentId: this.agent.id,
      //     ticketStatus: this.ticket.status,
      //     ticketPriority: this.ticket.priority,
      //     majorTaskTypeId: majorTaskTypeId,
      //     middleTaskTypeId: middleTaskTypeId,
      //     minorTaskTypeId: minorTaskTypeId,
      //     modifyBy: this.loginId
      //   }).then(result => {
      //     if (result.data.code !== 0) {
      //       this.$alertMsg(result.data.message)
      //       return
      //     }
      //     this.$alertMsg('수정이 완료되었습니다.')
      //   }).finally(() => {
      //     this.loading = false
      //   })
      // }
    },
    goList () {
      const goPath = String(this.$router.currentRoute.path).indexOf('list') > -1 ? '/ticket/list' : '/ticket/my_ticket'
      this.$router.push(goPath)
    },
    deleteTag (tag) {
      this.localTags.splice(this.localTags.indexOf(tag), 1)
    },
    sendTag () {
      let inputValue = this.tagInput.replace(/ /g, '')
      if (inputValue && this.localTags.indexOf(inputValue) === -1) {
        this.localTags.push(inputValue)
        this.removeTaginp()
      }
    },
    removeTaginp () {
      this.tagInput = ''
      this.resize()
    },
    // 간헐적으로 tags가 [] 로 넘어와 watch 에서 처리.
    // tags (newVal, oldVal) {
    //   this.initTags(newVal)
    // },
    resize () {
      setTimeout(() => {
        this.$refs.tagInp.$el.style.width = (this.$refs.tagHideTxt.offsetWidth + 60) + 'px'
      })
    },
    updateMajorTaskType (data) {
      this.majorTaskType = data
    },
    updateMiddleTaskType (data) {
      this.middleTaskType = data
    },
    updateMinorTaskType (data) {
      this.minorTaskType = data
    },
    resetTaskType () {
      this.$refs.ticketCounselType.resetAll()
      this.$refs.ticketCounselType.callMajorTaskType()
    },
    setKakaoInstantMessageAvailable () {
      this.kakaoInstantMessageAvailable = true
    },
    setSmsMessageAvailable () {
      this.smsMessageAvailable = true
    },
    showHistoryMemoDialog () {
      eventBus.$emit(event.OPEN_TICKET_MEMO_HISTORY_DIALOG, this.ticket.id)
    },
    initAgents () {
      this.agents = []
      if (this.ticketAgent) {
        this.ticketAgent.itemText = `${this.ticketAgent.name} (${this.ticketAgent.email})`
        this.agents.push(this.ticketAgent)
      }
    },
    findAgent (name) {
      this.loadingAgent = true
      let url = `/gateway/ticket/agent/list/${this.currentTicketBrandId}?page=1&size=20`
      if (name) {
        url += `&name=${encodeURIComponent(name)}`
      }

      this.axios.get(url)
        .then(res => {
          if (res.data.code === 0) {
            this.initAgents()

            const data = res.data.data
            data.filter(agent => agent.approvalStatus === '認証完了').forEach(agent => {
              let item = {id: agent.id, name: agent.name, email: agent.email}
              this.agents.push(item)
            })
          }
        })
        .finally(() => {
          this.loadingAgent = false
        })
    },
    getChannels () {
      this.$http.get('/api/module/message/channels', {
        params: {
          brandId: this.brandId
        }
      }).then(result => {
        let raw = result.data
        if (raw.code === 0) {
          this.refuseServiceNumbers = raw.data.refuseServiceNumbers
          raw.data.channels.map((d) => {
            if (this.$targetMake.isSeller && (d.channelName === 'KAKAO_INSTANT_MESSAGE' || d.channelName === 'SMS')) {
              this.msgCountData[d.channelName === 'KAKAO_INSTANT_MESSAGE' ? 'KAKAO' : 'SMS'] = d
            }
            this.channelData[d.channelName] = {
              serviceInfos: d.serviceInfos,
              templates: d.templates,
              notDimmed: true
            }
          })
        } else {
          this.$alertMsg(raw.message)
        }
      })
    },
    fetchSummaryCustomOption () {
      try {
        this.axios.get(`/api/brand/${this.brandId}/summary-options`)
          .then((result) => {
            if (result.data.code === 0) {
              const summaryOptions = result.data.data || []
              this.summaryOptionList = this.twoDepthArrayFromArray(summaryOptions, 2)

              if (summaryOptions.length) {
                summaryOptions.forEach(option => {
                  this.summaryOptionObject[option.code] = option
                })
              }
            }
          })
      } catch (e) {
        console.log(e)
      }
    },
    getItemList (code = null) {
      if (!code) {
        return []
      }

      const customOptionItem = (this.summaryOptionObject && this.summaryOptionObject[code]) || {}
      return (customOptionItem && customOptionItem.items) || []
    },
    twoDepthArrayFromArray (array = [], maxLength = 0) {
      if (!array.length || !maxLength) {
        return []
      }
      let oneDepthArr = []
      let twoDepthArr = []
      array.forEach(item => {
        const newItem = this.getCustomUserInfo(item)
        twoDepthArr.push(newItem)
        if (twoDepthArr.length === maxLength) {
          oneDepthArr.push(twoDepthArr)
          twoDepthArr = []
        }
      })

      return oneDepthArr
    },
    getItemPlaceholder ({ title = '', type = 'TEXT' }) {
      if (!title) {
        return ''
      }

      switch (type) {
        case 'TEXT':
          return `${title}を作成してください。`
        case 'SELECT':
          return `${title}を選択してください。`
      }
    },
    fetchItemInfo (selectedItem) {
      const option = (this.summaryOptionObject && this.summaryOptionObject[selectedItem.optionCode]) || {}
      if (option && option.items) {
        const selectedItemNewInfo = option.items.find(item => item.value === selectedItem.value)
        if (selectedItemNewInfo) {
          selectedItem.itemCode = selectedItemNewInfo.code
        }
      }
    },
    getCustomUserInfo (item = {}) {
      const customInfo = (this.summaryCustomObject && this.summaryCustomObject[item.code])
      if (typeof customInfo === 'object' && customInfo !== undefined) {
        customInfo.placeholder = item.placeholder
        return customInfo
      } else {
        return { optionCode: item.code, title: item.title, type: item.type, value: item.value, placeholder: item.placeholder }
      }
    },
    /* kt 콜 사용여부 조회 (서비스 목록 조회 목적) */
    checkCall () {
      this.$http.get('/api/brand/isUsableModuleChannel', {
        params: {
          brandId: this.brandId,
          moduleName: 'CALL',
          channelName: 'KT_CALL'
        }
      }).then(result => {
        if (result.data.code === 0) {
          this.getServiceList()
        }
      }).catch(err => {
        this.$alertMsg(err)
      })
    },
    /* 서비스 목록 조회 */
    getServiceList () {
      if (this.currentTicketBrandId) {
        this.$http.get(`/gateway/ticket-channels?ticketBrandId=${this.currentTicketBrandId}`).then(result => {
          if (result.data.code === 0) {
            this.serviceList = result.data.data.map(m => {
              return { value: m.channelId, name: `${m.serviceName} (${m.serviceNumber})` }
            })
          } else {
            this.$alertMsg(result.data.message)
          }
        }).catch(err => {
          this.$alertMsg(err)
        })
      }
    }
  },
  mounted () {
    if (this.currentTicketBrandId) {
      this.resetTaskType()
    }
  }
}
</script>
<style lang="scss">
  .ticketDetailCon {
    .ticketMergeBox {
      &.subOn {
        margin-bottom: -20px;
      }
      .ticket {
        position:relative;
        bottom: -2px;
        padding: 0 10px;
        color: $gray-8;
        span {
          padding-right:5px;
          color: $pb-6;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .ritTxt {
      padding-top:10px;
      color: $gray-6;
      font-size: 14px;
      text-align: right;
    }
    .cenBtn {
      padding:20px 0;
    }
    .listBox {
      margin-top:65px;
      padding-top:50px;
      border-top: 1px solid $gray-6;
      .UXTab {
        padding-bottom: 20px;
      }
    }
    .subTit {
      padding-top: 30px;
      padding-bottom: 5px;
      font-weight: bold;
      color: #414141;
      font-size: 14px;
      line-height: 20px;
    }
    .customSummaryTbl tbody tr th {
      >span {
        display: block;
        font-size: 12px;
        color: #919191;
        font-weight: normal;
        >span {
          color: $pb_6;
        }
      }
    }
  }
  .ticketSmsLayerCon {
    padding-top:15px;
    position: relative;
    .sms_body_con {
      height:264px !important;
      .scroll-y {
        padding-bottom:0;
      }
    }
    .dimmed {
      position: absolute;
      top:0;
      left:0;
      z-index: 1;
      width:100%;
      height: 100%;
      background-color: rgba(252,252,252,0.7);
      display: flex;
      justify-content: center;
      dl {
        position:absolute;
        top: 50%;
        margin:-35px 0 0 0px;
        padding: 20px;
        max-width: 290px;
        min-height: 70px;
        display:inline-block;
        text-align: center;
        box-shadow: 0px 0px 4px rgba(168, 168, 168, 0.25);
        background-color:#fff;
        dt {
          font-weight: bold;
          font-size: 16px;
          line-height: 22px;
          color: #ff8c8c;
        }
        dd {
          font-size: 14px;
          line-height: 20px;
          color: #939393;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
/deep/ .jodit_container {
  border-color: #BEBEBE !important;
  .jodit_workplace {
    min-height: auto !important;
  }
  .jodit-toolbar__box {
    border-color: #BEBEBE !important;
  }
}
/deep/ .jodit-container:not(.jodit_inline) {
  border-color: #BEBEBE !important;
}
/deep/ .jodit_disabled:not(.jodit_inline) {
  border-color: #E8E8E8 !important;
}

.smsLayer {
  /deep/ .UXTab .v-tabs__wrapper {
    .v-tabs__item--active,
    .v-tabs__container {
      background: white;
    }
  }
}

.callLayerCon {
  padding-top: 15px;
}

/*.ticketDetailCon .UXtagInp {*/
/*  /deep/ .v-input .v-input__slot {*/
/*    border: 1px solid #BEBEBE !important;*/
/*  }*/
/*}*/

.blue--text {
  color: #ff8c8c !important;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/ticket_details.vue